import { ObjectMeta } from "@supernova-studio/model";
import { z } from "zod";
import { DTOObjectMeta } from "../aux";

//
// Read
//

export const DTOBrand = z.object({
  id: z.string(),
  designSystemVersionId: z.string(),
  persistentId: z.string(),
  meta: ObjectMeta,
});

export const DTOBrandGetResponse = z.object({ brand: DTOBrand });

export const DTOBrandCreateResponse = z.object({
  brand: DTOBrand,
});

export const DTOBrandsListResponse = z.object({ brands: z.array(DTOBrand) });

export type DTOBrand = z.infer<typeof DTOBrand>;
export type DTOBrandGetResponse = z.infer<typeof DTOBrandGetResponse>;
export type DTOBrandCreateResponse = z.infer<typeof DTOBrandCreateResponse>;
export type DTOBrandsListResponse = z.infer<typeof DTOBrandsListResponse>;

//
// Write
//

export const DTOBrandCreatePayload = z.object({
  persistentId: z.string().uuid(),
  meta: DTOObjectMeta,
});

export const DTOBrandUpdatePayload = z.object({
  meta: DTOObjectMeta.optional(),
  persistentId: z.string(),
});

export type DTOBrandCreatePayload = z.infer<typeof DTOBrandCreatePayload>;
export type DTOBrandUpdatePayload = z.infer<typeof DTOBrandUpdatePayload>;
